export const SET_ACCOUNT_CONFIRMATION = 'Confirmation/SET_ACCOUNT_CONFIRMATION'; 